module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Successfully logged out!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27fd5ac0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Logout.vue
// module id = 316
// module chunks = 0